/** Byte protocols get ASCII; anything else prints as `?` (Bangla needs a raster path, not built yet). */
export const ascii = (text: string): number[] =>
  Array.from(text, (ch) => {
    const code = ch.charCodeAt(0)
    return code >= 0x20 && code < 0x7f ? code : 0x3f
  })

export const asciiText = (text: string) => String.fromCharCode(...ascii(text))

/** Words wrapped to `width` characters; a word longer than the line is cut. */
export const wrap = (text: string, width: number): string[] => {
  const lines: string[] = []
  let line = ''
  for (const word of text.split(/\s+/).filter(Boolean)) {
    if (line && line.length + 1 + word.length > width) {
      lines.push(line)
      line = ''
    }
    line = line ? `${line} ${word}` : word.slice(0, width)
  }
  if (line) lines.push(line)
  return lines.length ? lines : ['']
}

/** Left and right on one line of `width`; the left side is cut when both do not fit. */
export const row = (left: string, right: string, width: number) => {
  const room = Math.max(0, width - right.length - 1)
  const l = left.length > room ? left.slice(0, room) : left
  return `${l}${' '.repeat(Math.max(1, width - l.length - right.length))}${right}`
}

export const mmToDots = (mm: number, dpi: number) => Math.round((mm * dpi) / 25.4)
